import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import { ListingPage } from "../../utils/types/listing_page";

declare var ko: any;


export class listingPagesList_template extends vnTemplate{

    protected filter: filterSimple_template;
    protected resultInfos: resultsInfo_template;
    protected pagination: pagination_template;

    protected getTemplateHtml(): string{

        return `
            <div class="list-header w-justify">
               <div class="w-left" >
                    <button data-bind="event: {click: onClickAdd}" class="btn secondary icon i-add" type="button">Add Hub Page</button>
               </div>

               <div class="w-center">
                    ` + this.filter.getHtmlBuild() + `
               </div>

                <div class="w-right">
                    ` + this.pagination.getHtmlBuild() + `
                </div>
            </div>

            <div class="w-list-results" id="list-results">
                <table class="list-results">
                    ` + this.resultInfos.getHtmlBuild() + `
                    <thead>
                        <tr>

                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">Identifier</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC' }">Name</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'permalink') }, css: { 'list-sort-desc': orderByAndDirection()=='permalink_DESC', 'list-sort-asc': orderByAndDirection()=='permalink_ASC' }">Permalink</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'type') }, css: { 'list-sort-desc': orderByAndDirection()=='type_DESC', 'list-sort-asc': orderByAndDirection()=='type_ASC' }">Type</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'description') }, css: { 'list-sort-desc': orderByAndDirection()=='description_DESC', 'list-sort-asc': orderByAndDirection()=='description_ASC' }">Description</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }">Creation Date</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateUpdated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateUpdated_DESC', 'list-sort-asc': orderByAndDirection()=='dateUpdated_ASC' }">Update Date</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'articleCount') }, css: { 'list-sort-desc': orderByAndDirection()=='articleCount_DESC', 'list-sort-asc': orderByAndDirection()=='articleCount_ASC' }">Article Count</span></th>
                            <th><span>Delete</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: listingPages">
                        <tr class="cursor">
                            <td data-bind="event: { click: $parent.viewListingPage }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: id"></span></a></td>
                            <td data-bind="event: { click: $parent.viewListingPage }">
                                <a class="right-click" data-bind="attr: { href : emakiView }">
                                    <div class="flex">
                                        <span data-bind="text: name"></span>
                                        <button type="button" data-bind="event: { click: $parent.viewOnWebsite }" class="btn icon border only-icon i-link"></button>
                                    </div>
                                </a>
                            </td>
                            <td data-bind="event: { click: $parent.viewListingPage }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: permalink" ></span></a></td>
                            <td data-bind="event: { click: $parent.viewListingPage }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: type"></span></a></td>
                            <td data-bind="event: { click: $parent.viewListingPage }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: description"></span></a></td>
                            <td data-bind="event: { click: $parent.viewListingPage }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: dateCreated"></span></a></td>
                            <td data-bind="event: { click: $parent.viewListingPage }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: dateUpdated"></span></a></td>
                            <td data-bind="event: { click: $parent.viewListingPage }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: articleCount"></span></a></td>
                            <td>
                                <button class="btn border highlight only-icon icon i-delete" data-bind="visible: !isNotDeletable, event: { click: $parent.onClickDelete }" type="button" ></button>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>

            `;
    }

    protected initPartial(): void{

        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);

    }

    protected getTemplateName(): string{
        return "listingPagesList_template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string>{
        return ["w-content"];
    }

    protected buildViewModel(): any{

        let self = this;
        return{
            orderBy: ko.observable("name"),
            orderByDirection: ko.observable("ASC"),
            orderByAndDirection: ko.observable("name_ASC"),
            listingPages: ko.observableArray([]),
            isAddButtonShown: ko.observable(false),
            onClickReorder: (value, data, event) => {
                self.onClickReorder(value, data, event);
            },
            viewListingPage: (data, event) => {
                self.viewListingPage(data.id, event);
            },
            viewOnWebsite: (value, data, event) => {
                self.viewOnWebsite(value);
            },
            onClickDelete: (value, data, event) => {
                self.onClickDelete(value);
            },
            onClickAdd: (data, event) => {
                self.onClickAdd();
            }
        };
    }

    private viewOnWebsite(value) {

        //prevent click to trigger onClick bindings of outer elements that are also targeted by click
        window.event.stopPropagation();

        this.caller.viewOnWebsite(value.permalink);
    }

    public getViewModelForRequest(){

        return {
            orderBy : this.getTemplateViewModel().orderBy,
            orderByDirection : this.getTemplateViewModel().orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            pagination: this.getTemplateViewModel().pagination,
            filters      : {
                keywords: this.getTemplateViewModel().filter.filterKeyword,
            }
        }
    }

    public onClickReorder(value, data, event){

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.listingPagesListReorder();
    }

    public onClickAdd(){

        this.caller.add();
    }

    protected viewListingPage(data, event): any {
        this.caller.viewListingPage(data)
    }

    public onClickDelete(listingPage: ListingPage): void {

        //prevent click to trigger onClick bindings of outer elements that are also targeted by click
        window.event.stopPropagation();

        if(listingPage.isNotDeletable){
            return;
        }

        let deleteConfirmation: boolean = confirm('Are you sure you want to delete (' + listingPage.name + ') Hub Page.  Do you want to proceed?');
        if (deleteConfirmation == true) {
            this.caller.delete(listingPage.id);
        }
    }


    public setListingPages(listingPages: Array<ListingPage>, brandId): void {

        listingPages.forEach((lp) => lp['emakiView'] = '/brand/' + brandId + '/config/listing-pages/view/' + lp.id );

        this.getTemplateViewModel().listingPages(listingPages);
    }


    public setAddButtonShown(isAddButtonShown: boolean): void {

        this.getTemplateViewModel().isAddButtonShown(isAddButtonShown);
    }

    public setResultInfo(nbResults, nbPages, execTime ): void {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public setItemCount(count: number): void {

        this.pagination.getTemplateViewModel().itemCount(count);
    }

    public setPageNumber(page: number): void {
        this.pagination.getTemplateViewModel().pageNumber(page);
    }


}



// WEBPACK FOOTER //
// ./js/components/templates/listingPagesList_template.ts